import React from 'react';
import { formatTrendScore } from '../utils/scoreFormatUtils';
import { getTrendArrow } from '../utils/euTrendUtils';
import '../utils/sharedStyles.css';

// Trend arrow — D-26 / Pietro Q13.5: visually heavier symbols
export const TrendArrow = ({ category, score, size = 22, showCaption = true }) => {
  const { arrow, color } = getTrendArrow(category);
  const displayScore = formatTrendScore(score);
  const hasCategory = category != null && String(category).trim() !== '';
  const showScoreLine = showCaption && hasCategory;

  return (
    <div className={`goal-assessment-icon-container${showCaption ? '' : ' goal-assessment-icon-container--icon-only'}`}>
      <span
        className="goal-assessment-icon"
        style={{
          color: color,
          fontSize: size,
          fontWeight: 900,
          display: 'inline-block',
          minWidth: `${size}px`,
          textAlign: 'center',
          fontFamily: 'system-ui, -apple-system, sans-serif',
        }}
        title={category || 'Progress not available'}
      >
        {arrow}
      </span>
      {showCaption && (
        <div>
          <div className="goal-assessment-text">
            {category || 'Insufficient data'}
          </div>
          {showScoreLine && (
            <div style={{ fontSize: '0.75rem', color: '#666' }}>
              Score: {displayScore != null ? `${displayScore} / 5` : '— / 5'}
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default TrendArrow;

